import React, { useEffect, useState } from "react";
import Card from "components/card";
import TextField from "components/fields/TextField";
import CustomDropdown from "components/dropdown/CustomDropdown";
import { fetchData, createData } from "services/ApiFetching";
import toast from "react-hot-toast";
import { useModal } from "../../context/ModalContext"; // ✅ Import context

const NotificationModal = () => {
  const [message, setMessage] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");

  const { isNotificationOpen, closeNotification } = useModal();

  useEffect(() => {
    if (!isNotificationOpen) return;

    const loadUsers = async () => {
      try {
        const allUsers = await fetchData("users");
        const options = allUsers.map((user) => ({
          label: user.username,
          value: user.id,
        }));
        setUsers(options);
      } catch (error) {
        toast.error("Failed to load users");
      }
    };

    loadUsers();
  }, [isNotificationOpen]);

  const handleSendNotification = async () => {
    if (!message.trim() || !selectedUser) {
      toast.error("Please enter a message and select a user.");
      return;
    }

    try {
      await createData("notifications", {
        message,
        userId: selectedUser,
        sent_by: localStorage.getItem("username")
        });

      toast.success("Notification sent successfully!");
      setMessage("");
      setSelectedUser("");
      closeNotification(); // ✅ Close using context
    } catch (error) {
      console.error("Failed to send notification:", error);
      toast.error("Failed to send notification.");
    }
  };

  if (!isNotificationOpen) return null; // ✅ Do not render unless open

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <Card>
        <div className="flex flex-col p-4 w-[22vw] min-w-[350px]">
          <h2 className="text-xl font-bold text-navy-700 dark:text-white mb-4">
            Send Notification
          </h2>

          <TextField
            variant="auth"
            extra="mb-3"
            label="Message*"
            placeholder="Write your message"
            id="message"
            type="text"
            autoComplete="off"
            rows={5}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />

          <div className="mb-4">
            <label className="text-sm font-bold text-gray-700 dark:text-white mb-1 block">
              Select User*
            </label>
            <CustomDropdown
              label="Select User"
              options={users}
              value={selectedUser}
              onChange={(value) => setSelectedUser(value)}
            />
          </div>

          <div className="flex justify-between">
            <button
              onClick={handleSendNotification}
              className="px-4 py-2 bg-brand-500 text-white rounded-lg hover:bg-brand-600 transition-colors"
            >
              Send Notification
            </button>
            <button
              onClick={closeNotification} // ✅ context-based close
              className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-700 transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default NotificationModal;
